import templateUrl from "emun.order/vendor-review-orders/vendor-review-orders-list.htm";
import controller from "emun.order/vendor-review-orders/vendor-review-orders-list.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
